<template>
    <div v-if="coach" class="coach-row" @click="toCoachProfile" v-ripple>
        <student-avatar :avatar="coach.avatar" :name="coach.name" :avatar-key="coach.objectID" :size="56"
            :radius="10" />
        <div class="coach-info">
            <div class="coach-name">{{ coach.name || $t('common.not_available_short') }}</div>
            <div class="coach-sports">{{ sports || $t('common.not_available_short') }}</div>
            <div class="coach-tag">{{ coach.description || $t('common.not_available_short') }}</div>
        </div>
        <rating-stars :value="stars" size="14" />
    </div>
</template>

<script>

import StudentAvatar from '@/components/common/StudentAvatar'
import RatingStars from '@/components/common/RatingStars'

export default {
    name: "CoachRow",
    components: { StudentAvatar, RatingStars },
    props: {
        coach: {
            type: Object,
            default: null,
        }
    },
    computed: {
        sports(vm = this) {
            return (vm.coach?.sport_areas || []).map(sport => vm.sportLabel(sport)).join(', ')
        },
        stars(vm = this) {
            return vm.coach?.rating?.stars || 0
        },
    },
    methods: {
        toCoachProfile() {
            const vm = this
            vm.pushRoute({ name: 'student.coach-profile', params: { uid: vm.coach.objectID } })
        }
    }
}
</script>

<style scoped>
.coach-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    border-bottom: 1px solid var(--v-outline-base);
    cursor: pointer;
    transition: background 0.15s;
}

.coach-row:hover {
    background: var(--v-surface2-base);
}

.coach-info {
    flex: 1;
    min-width: 0;
}

.coach-name {
    font-size: 14px;
    font-weight: 700;
    color: var(--v-txtPrimary-base);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.coach-sports {
    font-size: 11px;
    color: var(--v-txtMuted-base);
    margin-top: 2px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.coach-tag {
    font-size: 11px;
    color: var(--v-txtSecondary-base);
    margin-top: 3px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
